export const BASE_URL =
    process.env.REACT_APP_BASE_URL || "https://api.bluehill.coffee";

export const LANDSCAPE_VIDEO_URL =
    process.env.REACT_APP_LANDSCAPE_VIDEO_URL ||
    "https://youtu.be/XeHO10AVcVY?si=FBEVpZf9SRC0VWo4";
export const PORTRAIT_VIDEO_URL =
    process.env.REACT_APP_PORTRAIT_VIDEO_URL ||
    "https://youtu.be/dkpkTR18Lv0?si=GcSShylhsdkfn1M2";

export const FALLBACK_LANDSCAPE_VIDEO_URL =
    process.env.REACT_APP_FALLBACK_LANDSCAPE_VIDEO_URL ||
    "https://youtu.be/XeHO10AVcVY?si=FBEVpZf9SRC0VWo4";
export const FALLBACK_PORTRAIT_VIDEO_URL =
    process.env.REACT_APP_FALLBACK_PORTRAIT_VIDEO_URL ||
    "https://youtu.be/dkpkTR18Lv0?si=GcSShylhsdkfn1M2";
export const VIDEO_BACKGROUND_COLOR =
    process.env.REACT_APP_VIDEO_BACKGROUND_COLOR || "#000";

export const REPORT_DEVICE_INTERVAL = process.env
    .REACT_APP_REPORT_DEVICE_INTERVAL
    ? parseInt(process.env.REACT_APP_REPORT_DEVICE_INTERVAL, 10)
    : 30 * 1000;
export const FETCH_PROMOTION_INTERVAL = process.env
    .REACT_APP_FETCH_PROMOTION_INTERVAL
    ? parseInt(process.env.REACT_APP_FETCH_PROMOTION_INTERVAL, 10)
    : 10 * 60 * 1000;
export const FETCH_WAITING_INTERVAL = process.env
    .REACT_APP_FETCH_WAITING_INTERVAL
    ? parseInt(process.env.REACT_APP_FETCH_WAITING_INTERVAL, 10)
    : 10 * 1000;
export const FETCH_ROBOT_INTERVAL = process.env
    .REACT_APP_FETCH_ROBOT_INTERVAL
    ? parseInt(process.env.REACT_APP_FETCH_ROBOT_INTERVAL, 10)
    : 30 * 60 * 1000;
export const FETCH_PRODUCT_INTERVAL = process.env
    .REACT_APP_FETCH_PRODUCT_INTERVAL
    ? parseInt(process.env.REACT_APP_FETCH_PRODUCT_INTERVAL, 10)
    : 30 * 60 * 1000;

export const PROMOTION_SWIPE_INTERVAL = process.env
    .REACT_APP_PROMOTION_SWIPE_INTERVAL
    ? parseInt(process.env.REACT_APP_PROMOTION_SWIPE_INTERVAL, 10)
    : 20000;

// ratio = width / height
export const LANDSCAPE_VIDEO_ASPECT_RATIO = process.env.REACT_APP_LANDSCAPE_VIDEO_ASPECT_RATIO
    ? parseFloat(process.env.REACT_APP_LANDSCAPE_VIDEO_ASPECT_RATIO)
    : 1.777777778;

export const PORTRAIT_VIDEO_ASPECT_RATIO = process.env.REACT_APP_LANDSCAPE_VIDEO_ASPECT_RATIO
    ? parseFloat(process.env.REACT_APP_LANDSCAPE_VIDEO_ASPECT_RATIO)
    : 0.5625;


export const HOT_DRINK = 'tvMenuGroup.hotDrink';
export const ICED_DRINK = 'tvMenuGroup.icedDrink';
export const FOOD = 'tvMenuGroup.food';
export const COFFEE_BEAN = 'tvMenuGroup.coffeeBean';

export const GROUPS = [HOT_DRINK, ICED_DRINK, FOOD, COFFEE_BEAN];
export const ARTLY_LOGO = 'ARTLY';


// Change default store config
export const BASE_STORE_CONFIG = {
    needAttachedSns: false,
    needSnsInWaitingPage: true,
    needAttachedQrcode: false,
    needQrcodeInWaitingPage: true,
    needAttachedLogos: [],
    needLogosInWaitingPage: [
        ARTLY_LOGO,
    ],
    landscapeVideo: {
        url: LANDSCAPE_VIDEO_URL,
        // we also can customize these flags for each video here to override the ones in top level
        // needAttachedLogos: [ARTLY_LOGO],
        // needAttachedSns: false,
        // needAttachedQrcode: false,
    },
    portraitVideo: {
        url: PORTRAIT_VIDEO_URL,
    },
    landscapeFallbackVideo: {
        url: FALLBACK_LANDSCAPE_VIDEO_URL,
    },
    portraitFallbackVideo: {
        url: FALLBACK_PORTRAIT_VIDEO_URL,
    },
};

const SEATTLE_STORE_CONFIG = {
    needAttachedSns: false,
    needSnsInWaitingPage: true,
    needAttachedQrcode: false,
    needQrcodeInWaitingPage: true,
    needAttachedLogos: [],
    needLogosInWaitingPage: [
        ARTLY_LOGO,
    ],
    landscapeVideo: {
        url: 'https://youtu.be/jYC1r0vFjEI?si=f5e7NctRST6wsR0_',
    },
    portraitVideo: {
        url: 'https://youtu.be/B-O912lefvM?si=LbNU8YwIlXkSXljn',
    },
    landscapeFallbackVideo: {
        url: FALLBACK_LANDSCAPE_VIDEO_URL,
    },
    portraitFallbackVideo: {
        url: FALLBACK_PORTRAIT_VIDEO_URL,
    },
};

const MUJI_HY_STORE_CONFIG = {
    needAttachedSns: false,
    needSnsInWaitingPage: true,
    needAttachedQrcode: false,
    needQrcodeInWaitingPage: true,
    needAttachedLogos: [],
    needLogosInWaitingPage: [
        ARTLY_LOGO,
    ],
    landscapeVideo: {
        url: 'https://youtu.be/LI41aDyqXpM?si=GAEUIQNrXhsj4bBc',
    },
    portraitVideo: {
        url: 'https://youtu.be/dkpkTR18Lv0?si=GcSShylhsdkfn1M2',
    },
    landscapeFallbackVideo: {
        url: FALLBACK_LANDSCAPE_VIDEO_URL,
    },
    portraitFallbackVideo: {
        url: FALLBACK_PORTRAIT_VIDEO_URL,
    },
}

const RCG_STORE_CONFIG = {
    needAttachedSns: false,
    needAttachedQrcode: false,
    needQrcodeInWaitingPage: false,
    needSnsInWaitingPage: true,
    needAttachedLogos: [],
    needLogosInWaitingPage: [
        ARTLY_LOGO,
    ],
    landscapeVideo: {
        url: 'http://127.0.0.1/video/video4tv.mp4',
    },
    portraitVideo: {
        url: 'http://127.0.0.1/video/video4tv.mp4',
    },
    landscapeFallbackVideo: {
        url: 'http://127.0.0.1/video/video4tv.mp4',
    },
    portraitFallbackVideo: {
        url: 'http://127.0.0.1/video/video4tv.mp4',
    },
};

export const CUSTOMIZED_STORE_CONFIG_BY_ID = {
    '18': SEATTLE_STORE_CONFIG,
    '20': SEATTLE_STORE_CONFIG,
    '-26': MUJI_HY_STORE_CONFIG,
    '26': MUJI_HY_STORE_CONFIG,
    '49': RCG_STORE_CONFIG,
};